import React from "react";
import BaseLayout from "layouts/base-layout";
import getCollection from "pms/collection";
import Collection from "components/collection";
import MetaTags from "components/meta";
import RenderModules from "helpers/render-modules";
import CoversBookGuide from "components/covers-book-guide";

const vehicleSubtypeToBookCover = {
    car: "car",
    boat: "boat",
    bimini: "boat",
    pontoon: "boat",
    jet_ski: "jet-ski",
};

const CollectionTemplate = ({ pageContext, serverData, location: { pathname }, handle, year }) => {
    const { settings, collectionTemplate } = pageContext;

    const vehicleSubtype = serverData?.products[0]?.vehicle_type;
    const hideModules = collectionTemplate?.hideOn?.includes(pathname);

    return (
        <BaseLayout settings={settings} path={pathname}>
            <div className="py-0 md:py-4 bg-white">
                <Collection
                    data={serverData}
                    variantColors={settings?.variantColors}
                    params={{ handle, year }}
                />
                {!hideModules && (
                    <>
                        {collectionTemplate && <RenderModules modules={collectionTemplate.modules} />}
                        {(vehicleSubtype && vehicleSubtypeToBookCover[vehicleSubtype]) && (
                            <div className="container mb-8">
                                <CoversBookGuide data={{ url: `https://my.sealskincovers.com/${vehicleSubtypeToBookCover[vehicleSubtype]}-cover-guide-embed/c.html`, title: `${vehicleSubtypeToBookCover[vehicleSubtype]} Book Cover Guide` }} />
                            </div>
                        )}
                    </>
                )}
            </div>
        </BaseLayout>
    );
};

export async function getServerData({ params }) {
    const { handle, year = null } = params;

    try {
        // eslint-disable-next-line no-console
        console.time(`getting collection ${handle} ${year}`);

        const data = await getCollection(handle, year);
        // eslint-disable-next-line no-console
        console.timeEnd(`getting collection ${handle} ${year}`);

        return { props: { products: data, handle } };
    } catch (err) {
        if (err.response.status === 404) return { status: 404, props: {} };
        throw new Error(err.message);
    }
}

const setExtraMeta = (handle) => [
    {
        type: "link",
        content: <link
            key="canonical-link"
            rel="canonical"
            href={`https://sealskincovers.com/collections/${handle}`}
        />,
    },
];

export const Head = ({ serverData }) => {
    const title = serverData?.products[0]?.checkout_attributes?.FITS || "SealSkin - Collection Page";

    // ToDo: Check why we don't receive handle as param?
    // But we have to send it from serverData
    const extraMeta = setExtraMeta(serverData?.handle);

    return (
        <MetaTags
            meta={{
                title, description: null, pageType: "product.group",
            }}
            extra={extraMeta}
        />
    );
};

export default CollectionTemplate;
